"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExportItemToString = transformExportItemToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformExportItemToString(exportItem) {
    switch (exportItem) {
        case legacy_enums_1.ExportItem.OrderPrices:
            return "order prices";
        case legacy_enums_1.ExportItem.AdCustomizer:
            return "ad customizer feed";
        case legacy_enums_1.ExportItem.DriversOrdersBalances:
            return "drivers balances";
        case legacy_enums_1.ExportItem.TravelAgentReport:
            return "travel agent report";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformExportItemToString.js.map